<ng-container>
    <td
        *ngIf="hasActions || showCalc"
        [ngClass]="{
            'column-type--actions': hasActions,
            'column-type--calc': showCalc
        }"
    >
        <button
            emmaButton
            *ngIf="calcSummary === 'avg'"
            [color]="colorSummaryBtn"
            [hasIcon]="true"
            [onlyIcon]="true"
            [isCircle]="true"
            sizeButton="xs"
            (click)="$calc.emit('sum')"
            container="body"
            [ngbPopover]="popContent"
            i18n-ngbPopover
        >
            <i [class]="'iconemma-media-summary'" aria-hidden="true"></i>
        </button>
        <button
            emmaButton
            *ngIf="calcSummary === 'sum'"
            [color]="colorSummaryBtn"
            [hasIcon]="true"
            [onlyIcon]="true"
            [isCircle]="true"
            sizeButton="xs"
            (click)="$calc.emit('avg')"
            container="body"
            [ngbPopover]="popContent"
            i18n-ngbPopover
        >
            <i [class]="'iconemma-total-summary'" aria-hidden="true"></i>
        </button>
    </td>
    <th
        *ngFor="let col of columns"
        [id]="col.prop"
        [class]="'column-type--' + (col.dataType ? col.dataType : 'default')"
        emma-table-row-cell
        [value]="getProp(summaryCache, col.prop)"
        [column]="col"
    ></th>
</ng-container>
<ng-template #popContent>
    <span i18n>Cambiar a </span><b *ngIf="calcSummary === 'avg'" i18n>totales</b><b *ngIf="calcSummary === 'sum'" i18n>media</b><span i18n> de cada columna.</span>
</ng-template>
